import { StoryElementType } from 'webapp/enums/enums';

import StoryElementBase from 'webapp/models-custom/story-element/base';

export default class StoryElementDateRange extends StoryElementBase {
	type = StoryElementType.DATE_RANGE;
	longTitle = 'Date range';

	override get isLoading(): boolean {
		return super.isLoading || !this.dateRange;
	}

	openEdit(_node: HTMLElement): void {
		this.openAdvanced();
	}

	fillElementContent(node: HTMLElement): void {
		const text = this.dateRange?.rangeTitleUX || '<unknown>';
		node.textContent = text;
	}
}
